import React, { useState } from 'react';
import { clearAll } from './Board.js';
import { useEffect } from 'react';
import { data } from './Board.js';
import '../styles/RefreshButton.css'
import {BiRefresh} from 'react-icons/bi'
import ReactGA from 'react-ga4';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA

function RefreshButton(props) {

    const clearAllFunction = () => {
        data.paused=true;
        console.log("Clear")
        setTimeout(() => {
            clearAll();
          }, 500);
          ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Reset/Refresh button is Clicked'
          });
        
    }

    return (
        <div className='refresh-but-div'>
            <button className='btn-primary' onClick={clearAllFunction}>
                <BiRefresh size={30} />
            </button>
        </div>
    );
}

export default RefreshButton;